export const tracksState = {
    defaultState: {
        tracks: [],
    },
    actions: {
        appendTracks: (tracks, state) => ({...state, tracks: [
            ...new Map([
                ...state.tracks,
                ...tracks.filter(i => !i.playlist)
            ].map(item => [item.id, item])).values()
        ]}),
        trackHistory: [],
        trackHistoryIndex: -1,
    },
}
